<template>
    <div id="demo-basic-card" class="margin-top-hashtag">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="vx-card p-2 pt-0">
                    <div class="vx-row mt-2">
                        <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="md:w-4/12 ml-auto input-rounded-full" v-model="searchHastag" placeholder="#hashtag" @input="searchHashtagQuery"></vs-input>
                        <vs-button class="ml-6 mr-auto border-button" @click="findDataByHashtag"> {{ $t('hashtag.search') }}</vs-button>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-4" v-if="checkSearch">
                <!-- Pages Suggestion -->
                <div class="vx-col md:w-5/12 w-full m-auto">
                    <div class="vx-card">
                        <div class="component w-full pt-2">
                            <span class="font-bold mx-4">{{ $t('hashtag.recentSearches') }}</span>
                        </div>
                        <vs-table stripe :data="listSearchHashtag" :noDataText="this.$t('noData')"  class="w-full mt-2">
                            <template>
                                <vs-tr
                                v-for="(item, index) in listSearchHashtag"
                                :data="item"
                                :key="index">
                                <vs-td>
                                    <div class="component w-full md:w-10/12" @click="selectedSearchHashtag(item)">
                                        <span class="text-primary">{{ item || 0}}</span>
                                    </div>
                                </vs-td>
                                <vs-td class="text-content md:w-2/12 w-full">
                                    <feather-icon icon="Trash2Icon" style="width:1.2rem" @click="removeDataSearch(item)"></feather-icon>
                                </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
            <div class="component" v-if="!checkSearch">
                <div class="vx-row mt-4">
                    <div class="w-full">
                        <span>{{ $t('hashtag.result') }} (từ {{from}} - {{to}})</span>
                    </div>
                    <div class="component flex w-full">
                        <div class="w-full md:w-2-/12">
                            <span class="text-danger font-medium font-size-hashtag">{{ searchHastag || '#hashtag' }}</span>
                        </div>
                        <div class="md:w-10/12 w-full flex">
                            <vs-button class="ml-auto" icon-pack="feather" icon="icon-download">{{ $t('hashtag.download') }}</vs-button>
                        </div>
                    </div>
                </div>
                <div class="vx-row mt-4">
                    <div class="vx-card rounded-card">
                        <div class="vx-row">
                            <div class="vx-col md:w-1/6 w-full text-center" v-for="(card, cardIndex) in listDataCard" :key="cardIndex">
                                <statistics-card-line
                                :background="card.bg"
                                :icon="card.icon"
                                type="area"
                                :color="card.color"
                                :colorTo="card.cardBackground"
                                :height="61"
                                :hideChart="true"
                                :statistic="card.statistic"
                                :statisticTitle="card.title"
                                :checkPercent="card.check"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row mt-4">
                    <div class="vx-col md:w-2/3 w-full pl-0">
                        <div class="vx-card p-6">
                            <div class="component">
                                <span class="text-title">
                                    {{ $t("capacity") }}
                                    <div v-if="!showWorkChart" class="lds-facebook">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    </div>
                                </span>
                            </div>
                            <div class="component">
                                <span class="text-time-title">
                                    {{ countDays }} {{ $t("day")}}
                                    <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                                    </span>
                                </span>
                            </div>
                            <div id="chart">
                                <vue-apex-charts
                                    v-if="showWorkChart"
                                    type="bar"
                                    height="360"
                                    :options="capacityChart.chartOptions"
                                    :series="capacityChart.series">
                                </vue-apex-charts>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full p-0">
                        <div class="vx-card card-height-hashtag">
                            <div class="component mx-4 pt-6">
                                <span class="text-title">
                                    {{ $t("hashtag.topHashtag") }}
                                </span>
                            </div>
                            <div class="component">
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full text-left pl-8">
                                        <span class="text-time-title" style="font-size:14px">
                                            Hastag
                                        </span>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full text-right pr-10">
                                        <span class="text-time-title" style="font-size:14px">
                                            {{ $t('hashtag.numberOfTurns') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <vs-table stripe :data="listTopHashtag" :noDataText="this.$t('noData')"  class="w-full mt-2 table-hashtag">
                                <template>
                                    <vs-tr
                                    v-for="(item, index) in listTopHashtag"
                                    :data="item"
                                    :key="index">
                                    <vs-td>
                                        <div class="component w-full md:w-10/12">
                                            <span class="text-primary">#{{ item.hashtagName }}</span>
                                        </div>
                                    </vs-td>
                                    <vs-td class="text-content md:w-2/12 w-full">
                                        <span>{{ eArabic(item.count) }}</span>
                                    </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>

                <card-hashtag :hashTagName="hashTagSearch" :refreshData="refreshData"></card-hashtag>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import StatisticsCardLine from "../hashtag/statis-card/StatisticsCardLineHashtag.vue"
import CardHashtag from '../hashtag/card-hashtag/CardHashtag.vue'
import VueApexCharts from "vue-apexcharts";
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
export default {
    components:{
        StatisticsCardLine,
        CardHashtag,
        VueApexCharts,
        VxAutoSuggest
    },
    data(){
        return {
            refreshData: null,
            staticHashtag: {},
            checkSearch: false,
            listTopHashtag: [],
            listSearchHashtag: [],
            listDataCard: [
                {statistic: 0, title: 'Lượt sử dụng', icon: 'HashIcon', color: 'rgba(255, 61, 84)', bg: '#fff',cardBackground: 'rgba(255, 61, 84, 0.15)', check: false},
                {statistic: 0, title: 'Trong bài viết', icon: 'FileTextIcon', color: 'rgba(40, 199, 111)', bg: '#fff',cardBackground: 'rgba(40, 199, 111, 0.15)', check: false},
                {statistic: 0, title: 'Trong bình luận', icon: 'TwitchIcon', color: 'rgba(115, 103, 240)', bg: '#fff',cardBackground: 'rgba(115, 103, 240, 0.15)', check: false},
                {statistic: 0, title: 'User', icon: 'UsersIcon', color: 'rgba(254, 196, 0)', bg: '#fff',cardBackground: 'rgba(254, 196, 0, 0.15)', check: false},
                {statistic: 0, title: 'Hashtag/User', icon: 'UserIcon', color: 'rgba(253, 198, 198)', bg: '#fff',cardBackground: 'rgba(253, 198, 198, 0.15)', check: false},
                {statistic: 0, title: 'Tổng dữ liệu thu thập', icon: 'AtSignIcon', color: 'rgba(47, 128, 237)', bg: '#F8F8F8',cardBackground: 'rgba(47, 128, 237, 0.15)', check: true},
            ],
            searchHastag: null,
            hashTagSearch: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                let date = new Date();
                date.setDate(date.getDate() - 29);
                date.setHours(0, 0, 0);
                return date;
                })()
            },
            from: null,
            to: null,

            //check chart
            showWorkChart: false,

            //capacity chart
            capacityChart: {
                series: [10,20,30,40],
                chartOptions: {
                chart: {
                    type: "bar",
                    height: 360,
                    stacked: true,
                    // stackType: '100%'
                },
                colors: ['#28C76F', '#7367F0'],
                responsive: [
                    {
                    breakpoint: 480,
                    options: {
                        legend: {
                        position: "bottom",
                        offsetX: -10,
                        offsetY: 0
                        }
                    }
                    }
                ],
                markers: {
                    size: 0,
                    hover: {
                    size: 5
                    }
                },
                xaxis: {
                    labels: {
                    showDuplicates: false,
                    formatter: function(val) {
                        if (!val) return val;
                        let dateSplit = val.split("-"),
                        type = dateSplit[1],
                        dateTemp = moment(dateSplit[0], "YYYYMMDD");

                        if (type === "W") return `Tuần ${dateTemp.isoWeek()}`;

                        if (type === "M")
                        return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                        return val.slice(6, 8) + "/" + val.slice(4, 6);
                    },
                    style: {
                        cssClass: "text-grey fill-current"
                    }
                    },
                    axisTicks: {
                    show: false
                    },
                    categories: [],
                    tooltip: {
                    enabled: false
                    }
                },
                yaxis: {
                    tickAmount: 5,
                    labels: {
                    style: {
                        cssClass: "text-grey fill-current"
                    },
                    formatter: function(val) {
                        if (Number(val) === val && val % 1 !== 0) {
                        return kFormatter(val).toFixed(1);
                        } else {
                        return kFormatter(val);
                        }
                    }
                    },
                    grid: {
                    show: false
                    }
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: false,
                    position: "top",
                    // offsetX: 0,
                    // offsetY: 50
                    markers: {
                    fillColors: ["#2F80ED", "#27AE60", "#9B51E0", "#F2994A"]
                    }
                }
                }
            },
        }
    },
    methods: {
        removeDataSearch: function(item){
            let indexData = this.listSearchHashtag.indexOf(item);
            if (indexData >= 0 ) {
                this.listSearchHashtag.splice(indexData, 1);
                localStorage.setItem('dataSearch', JSON.stringify(this.listSearchHashtag));
            }
        },
        getTopHashtag: function(condition){
            this.$processor.post('/user-data/top-hashtag', condition).then((res) => {
                this.listTopHashtag = res.data;
                if (res.data.length > 10) this.listTopHashtag = res.data.slice(0, 10);
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getStaticHashtag: function(condition){
            this.$processor.post('/user-data/get-hashtag', condition).then((res) => {
                let result = res.data;
                let percent = ((result.totalUsed/result.totalAllData) * 100).toFixed(0);
                this.listDataCard[0].statistic = result.totalAllData;
                this.listDataCard[1].statistic = result.totalPost;
                this.listDataCard[2].statistic = result.totalComment;
                this.listDataCard[3].statistic = result.totalUsed;
                this.listDataCard[4].statistic = result.totalUser;
                this.listDataCard[5].statistic = !isNaN(percent) ? percent : 0;

            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getHashtagByDay: function(condition){
            this.showWorkChart = false;
        let that = this;
        this.$processor
            .post("/user-data/data-by-day-hashtag", condition)
            .then(res => {
            res.data.hashtagCommentDataByDay = this.optimizedChart(res.data.hashtagCommentDataByDay);
            res.data.hashtagPostDataByDay = this.optimizedChart(res.data.hashtagPostDataByDay);

            that.hashtagChartData = res.data;
            let postHashtag = {
                name: "Tin bài",
                data: that.hashtagChartData.hashtagPostDataByDay.map(x => {
                return x.totalData;
                })
            };
            let commentHashtag = {
                name: "Bình luận",
                data: that.hashtagChartData.hashtagCommentDataByDay.map(x => {
                return x.totalData;
                })
            };
            that.capacityChart.series = [];
            that.capacityChart.chartOptions.xaxis.categories = [];
            that.capacityChart.chartOptions.xaxis.categories.push(
                ...that.hashtagChartData.hashtagCommentDataByDay.map(x => {
                return x.stringDate;
                })
            );
            that.capacityChart.series.push(
                postHashtag,
                commentHashtag
            );
            that.showWorkChart = true;
            that.$vs.loading.close();
            });
        },
        findDataByHashtag: function(){
            if (this.searchHastag.length > 0){
                let data = localStorage.getItem('dataSearch');
                if (!data) {
                    let dataSearch = [];
                    dataSearch[0] = this.searchHastag;
                    localStorage.setItem('dataSearch', JSON.stringify(dataSearch));
                }
                else {
                    let result = JSON.parse(data);
                    if (!result.includes(this.searchHastag)) {
                        result.push(this.searchHastag);
                        localStorage.setItem('dataSearch', JSON.stringify(result));
                    }
                }
            }
            this.checkSearch = false;
            this.refreshData += 1;
            this.initScreen();
        },
        searchHashtagQuery: function(){
            this.checkSearch = true;
            if (!this.searchHastag) {
                this.checkSearch = false;
            }
        },
        selectedSearchHashtag: function(item){
            this.searchHastag = item;
        },
        getDataWorkChart(conditions) {
        this.showWorkChart = false;
        let that = this;
        this.$processor
            .post("/user-data/get-work-by-day", conditions)
            .then(res => {
            res.data.mentionByDays = this.optimizedChart(res.data.mentionByDays);
            res.data.commentByDays = this.optimizedChart(res.data.commentByDays);
            res.data.shareByDays = this.optimizedChart(res.data.shareByDays);

            that.workChartData = res.data;
            let mentionByDays = {
                name: this.$t("title.mentioned"),
                data: that.workChartData.mentionByDays.map(x => {
                return x.totalData;
                })
            };
            let commentByDays = {
                name: this.$t("title.comment"),
                data: that.workChartData.commentByDays.map(x => {
                return x.totalData;
                })
            };
            let shareByDays = {
                name: this.$t("title.share"),
                data: that.workChartData.shareByDays.map(x => {
                return x.totalData;
                })
            };
            that.capacityChart.series = [];
            that.capacityChart.chartOptions.xaxis.categories = [];
            that.capacityChart.chartOptions.xaxis.categories.push(
                ...that.workChartData.mentionByDays.map(x => {
                return x.stringDate;
                })
            );
            that.capacityChart.series.push(
                mentionByDays,
                commentByDays,
                shareByDays
            );
            that.showWorkChart = true;
            that.$vs.loading.close();
            });
        },
        countDateRange: function(fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.countDays = diffDays;
        },
        initScreen(){
            if (this.searchHastag && this.searchHastag.length > 0) this.hashTagSearch = this.searchHastag.replace('#', '');
            else this.hashTagSearch = this.searchHastag;
            let resultDataSearch = JSON.parse(localStorage.getItem('dataSearch'));
            this.listSearchHashtag = resultDataSearch;
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
            let fromDate = this.dateRange.startDate;
            let toDate = this.dateRange.endDate;
            let conditions = {
                hashtagName: this.hashTagSearch,
                from: fromDate,
                to: toDate,
                beanTypeSocial: [],
                pageNumber: 0,
                pageSize: 20
            };
            this.countDateRange(this.dateRange.startDate, this.dateRange.endDate);
            this.getTopHashtag(conditions);
            this.getStaticHashtag(conditions);
            this.getHashtagByDay(conditions);
        },
        optimizedChart: function(data) {
            data = data.sort(function(a, b) {
                return parseInt(a.stringDate) - parseInt(b.stringDate);
            });
            data.map(item => {
                let date = moment(item.stringDate, "YYYYMMDD");
                item.month = date.format("Y") + date.format("M");
                item.week = date.isoWeek();
                item.day = date.format("D");
                return item;
            });

            let result = [];
            data.reduce(function(res, value) {
                if (data.length <= 21) {
                if (!res[value.day]) {
                    res[value.day] = {
                    day: value.day,
                    stringDate: value.stringDate,
                    totalData: 0
                    };
                    result.push(res[value.day]);
                }
                res[value.day].totalData += value.totalData;
                res[value.day].stringDate += "-D";
                return res;
                }
                if (14 < data.length && data.length < 62) {
                if (!res[value.week]) {
                    res[value.week] = {
                    week: value.week,
                    stringDate: value.stringDate,
                    totalData: 0
                    };
                    result.push(res[value.week]);
                }
                res[value.week].totalData += value.totalData;
                res[value.week].stringDate += "-W";
                return res;
                } else if (data.length > 62) {
                if (!res[value.month]) {
                    res[value.month] = {
                    month: value.month,
                    stringDate: value.stringDate,
                    totalData: 0
                    };
                    result.push(res[value.month]);
                }
                res[value.month].totalData += value.totalData;
                res[value.month].stringDate += "-M";
                return res;
                }
            }, {});
            data = result;
            return data;
        },
        eArabic: function(x) {
            return x.toLocaleString("de-DE");
        },
    },
    created(){
        this.initScreen();
        this.from = moment(this.dateRange.startDate).format('DD/MM/YYYY');
        this.to = moment(this.dateRange.endDate).format('DD/MM/YYYY')
    }
}
function kFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}
</script>

<style>
.border-button {
    border-radius: 20px;
}
.font-size-hashtag {
    font-size: 24px;
}
.rounded-card {
    border-radius: 0.5rem;
}
.text-title {
  font-size: 19px;
  font-weight: bold;
}
.text-time-title {
  font-size: 12px;
  color: #B9B9C3;
}
.card-height-hashtag {
    height: 466px;
}
.table-hashtag .con-tablex .vs-con-tbody {
  max-height: 385px;
  z-index: 1;
  overflow-x: hidden;
}
.table-hashtag .con-tablex .vs-con-tbody .vs-table--tbody-table {
  min-width: 320px !important;
}
.table-hashtag .vs-table--tbody-table .tr-values.selected {
  cursor: default
}
.margin-top-hashtag {
    margin-top: -16px;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>
